var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('div',{class:_vm.classNames,on:{"click":function($event){return _vm.onHeadlineClick(_vm.id)}}},[_vm._v(" ... ")]):_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }